import React, { FC } from 'react';
import { MaterialIcon } from '../material-icon/MaterialIcon';
import styles from './common_error_message.module.scss';

type Props = {
  error: string;
};

export const CommonErrorMessage: FC<Props> = ({ error }) => (
  <div className={styles.container}>
    <MaterialIcon name="error_outline" className={styles.icon} />
    {error}
  </div>
);
